import { Card } from "@/components/ui/card";
import { getValidHttpUrl } from "@/lib/url";

interface TwitterPreviewProps {
  metaTags: {
    twitter_title?: string;
    twitter_image?: string;
    twitter_image_alt?: string;
    og_image?: string;
  };
}

export default function TwitterPreview({ metaTags }: TwitterPreviewProps) {
  const { twitter_title, twitter_image, twitter_image_alt, og_image } = metaTags;
  const previewImage = getValidHttpUrl(twitter_image) ?? getValidHttpUrl(og_image);

  return (
    <Card className="relative w-full max-w-lg overflow-hidden rounded-2xl border p-0 py-0 shadow-md">
      <div className="relative w-full">
        {previewImage ? (
          <img
            src={previewImage}
            alt={twitter_image_alt ?? twitter_title ?? ""}
            className="aspect-[1.91/1] w-full object-cover"
          />
        ) : (
          <div className="flex h-64 w-full items-center justify-center bg-gray-200 dark:bg-gray-800">
            <p className="text-gray-500 dark:text-gray-300">No image available</p>
          </div>
        )}
        {previewImage ? (
          <div
            className="pointer-events-none absolute bottom-0 left-0 m-4 rounded bg-black/80 px-3 py-1 text-xs font-medium text-white dark:text-gray-100"
            style={{ backdropFilter: "blur(2px)" }}
          >
            {twitter_title}
          </div>
        ) : null}
      </div>
    </Card>
  );
}
